"use strict";
module.exports = ['$translate', '$http', '$httpParamSerializer', 'ngDroUAACommon', function ($translate, $http, $httpParamSerializer, ngDroUAACommon) {

        this.get = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile')
            });
        };

        this.updatePassword = function (data, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'PUT',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile'),
                data: data
            });
        };

        this.update = function (data, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'PUT',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile/update'),
                data: data
            });
        };

        this.current = function (usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile/user')
            });
        };

        this.updateBadge = function (data, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'POST',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile/badge'),
                transformRequest: angular.identity,
                headers: {'Content-Type': undefined},
                data: data
            });
        };

        this.getBadge = function (id, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'GET',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile/badge/' + id)
            });
        };

        this.canDo = function (resource, privilege, usePrefix) {
            ngDroUAACommon.setUsePrefix(usePrefix || true);

            return $http({
                method: 'POST',
                withCredentials: true,
                url: ngDroUAACommon.getUrl('api/profile/can-do'),
                data: {resource: resource, privilege: privilege},
                sendErrors: false
            });
        };

        return {
            get: this.get,
            current: this.current,
            update: this.update,
            updatePassword: this.updatePassword,
            updateBadge: this.updateBadge,
            getBadge: this.getBadge,
            canDo: this.canDo
        };
    }];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/services/rest/profile.js
// module id = 394
// module chunks = 0